import { useTranslation } from '@/i18n';

import { FC, useEffect, useState, type JSX } from 'react';
import { Helmet } from 'react-helmet';

import DefaultAutomationControl from '@/ui/components/defaultAutomationControl/DefaultAutomationControl';
import { getDefaultAutomationDefinition } from '@payaca/store/automations/automationActions';
import { requestGetUploadsForEntity } from '@payaca/store/uploads/uploadsActions';
import {
  AutomationActionTypes,
  HydratedDefaultAutomationDefinition,
  PublicHydratedDefaultAutomationDefinition,
} from '@payaca/types/automationTypes';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import AuthenticatedPageWrapper from '../pageWrappers/authenticatedPageWrapper/AuthenticatedPageWrapper';
import './DefaultAutomationPage.sass';

type Props = {
  defaultAutomationDefinitionPublicId: HydratedDefaultAutomationDefinition<AutomationActionTypes>['publicId'];
};

const DefaultAutomationPage: FC<Props> = ({
  defaultAutomationDefinitionPublicId,
}): JSX.Element | null => {
  const translate = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const [defaultAutomationDefinition, setDefaultAutomationDefinition] =
    useState<
      PublicHydratedDefaultAutomationDefinition<AutomationActionTypes>
    >();

  useEffect(() => {
    if (defaultAutomationDefinitionPublicId?.length) {
      dispatch(
        getDefaultAutomationDefinition.request({
          defaultAutomationDefinitionPublicId:
            defaultAutomationDefinitionPublicId,
          callback: setDefaultAutomationDefinition,
        })
      );
    }
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'dispatch'
  }, [defaultAutomationDefinitionPublicId]);

  useEffect(() => {
    if (defaultAutomationDefinition?.automation?.actions[0].uploadIds.length) {
      dispatch(
        requestGetUploadsForEntity(
          defaultAutomationDefinition?.automation?.actions[0].id,
          'automationAction'
        )
      );
    }
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has a complex expression in the dependency array.
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has missing dependencies: 'defaultAutomationDefinition.automation.actions', and 'dispatch'
  }, [defaultAutomationDefinition?.automation?.actions[0].uploadIds]);

  return (
    <>
      <Helmet
        title={
          defaultAutomationDefinition?.title ||
          translate('pages.automation.title')
        }
      />
      <AuthenticatedPageWrapper
        breadcrumbItems={[
          { label: 'Back', to: '/automations?tab=default' },
          { label: 'Default Automation' },
        ]}
        className="default-automation-page"
      >
        <div className="p-4">
          {defaultAutomationDefinition && (
            <DefaultAutomationControl
              defaultAutomationDefinition={defaultAutomationDefinition}
              onUpdateAutomationSuccess={(automation) => {
                defaultAutomationDefinition.automation = automation;
                history.push('/automations?tab=default');
              }}
            />
          )}
        </div>
      </AuthenticatedPageWrapper>
    </>
  );
};

export default DefaultAutomationPage;
